/**
 * TikTok Pixel — consent-gated, lazy-loaded.
 *
 * Das Pixel-Script wird erst geladen und initialisiert, nachdem der
 * Nutzer zugestimmt hat. Kein statisches <script>-Tag in index.html.
 */

import { getConsent, onConsentChange } from './consent';

const PIXEL_ID = process.env.REACT_APP_TIKTOK_PIXEL_ID;

let initialized = false;

function loadScript() {
  return new Promise((resolve) => {
    if (document.getElementById('tiktok-pixel-script')) {
      resolve();
      return;
    }
    const script = document.createElement('script');
    script.id = 'tiktok-pixel-script';
    script.async = true;
    script.src = 'https://analytics.tiktok.com/i18n/pixel/events.js?sdkid=' + PIXEL_ID + '&lib=ttq';
    script.onload = resolve;
    script.onerror = resolve; // Nicht blockieren wenn der CDN nicht erreichbar
    document.head.appendChild(script);
  });
}

async function enable() {
  if (initialized || !PIXEL_ID) return;

  // TikTok Pixel Basis-Snippet (inline bootstrap, analog zum offiziellen Snippet)
  if (typeof window.ttq === 'undefined') {
    /* eslint-disable */
    window.TiktokAnalyticsObject = 'ttq';
    const ttq = (window.ttq = window.ttq || []);
    ttq.methods = ['page', 'track', 'identify', 'instances', 'debug', 'on', 'off', 'once', 'ready', 'alias', 'group', 'enableCookie', 'disableCookie', 'holdConsent', 'revokeConsent', 'grantConsent'];
    ttq.setAndDefer = function (t, e) { t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))); }; };
    ttq.methods.forEach((e) => ttq.setAndDefer(ttq, e));
    ttq.instance = function (t) { const e = ttq._i[t] || []; ttq.methods.forEach((n) => ttq.setAndDefer(e, n)); return e; };
    ttq.load = function (e, n) { const r = 'https://analytics.tiktok.com/i18n/pixel/events.js'; ttq._i = ttq._i || {}; ttq._i[e] = []; ttq._i[e]._u = r; ttq._t = ttq._t || {}; ttq._t[e] = +new Date(); ttq._o = ttq._o || {}; ttq._o[e] = n || {}; };
    /* eslint-enable */
  }

  await loadScript();

  window.ttq.load(PIXEL_ID);
  window.ttq.page();
  initialized = true;
}

function disable() {
  // Pixel deaktivieren (Consent entzogen)
  if (window.ttq && typeof window.ttq.revokeConsent === 'function') {
    window.ttq.revokeConsent();
  }
  initialized = false;
}

/** Initialisiert TikTok Pixel und hört auf Consent-Änderungen */
export function initTikTok() {
  if (!PIXEL_ID) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('[TikTok] REACT_APP_TIKTOK_PIXEL_ID nicht gesetzt — Pixel deaktiviert.');
    }
    return;
  }

  if (getConsent() === 'granted') {
    enable();
  }

  onConsentChange((value) => {
    if (value === 'granted') {
      enable();
    } else {
      disable();
    }
  });
}

/**
 * Beliebiges TikTok-Event tracken — nur wenn Consent + initialisiert.
 * Beispiel: trackEvent('CompleteRegistration')
 */
export function trackEvent(eventName, params = {}) {
  if (getConsent() !== 'granted' || !initialized || !window.ttq) return;
  window.ttq.track(eventName, params);
}

/** Page-View tracken (für SPA-Navigation) */
export function trackPageView() {
  if (getConsent() !== 'granted' || !initialized || !window.ttq) return;
  window.ttq.page();
}
